var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureNoCircleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.333 30.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.449,14.449H0V0H14.449Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.449,14.449H177V0h14.447V14.449Z",
    transform: "translate(-161.115)",
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.449,191.449H0V177H14.449Z",
    transform: "translate(0 -161.115)",
    fill: "#A7A7A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.449,191.449H177V177h14.447v14.449Z",
    transform: "translate(-161.115 -161.115)",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureNoCircleDisabled);
export default __webpack_public_path__ + "static/media/azure-no-circle-disabled.5d1a4eecb62f0458e4c0d1e29a61aa55.svg";
export { ForwardRef as ReactComponent };